import FormSwitch from "../base/FormSwitch";

export default class InputCheckSwitch extends FormSwitch {

    render() {
        return super.render();
    }
}